<template lang="pug">
.b-user-assigning
  UserUniversalTile._from(
    :class="{ empty: !from }"
    :selected="from"
    v-bind="$attrs"
    v-on="$listeners"
    :editable="fromEditable"
    @change="$emit('fromChanged', $event)"
    :isClearable="false"
    )
  ._arrow
  UserUniversalTile._to(
    :class="{ empty: !to }"
    :selected="to"
    v-bind="$attrs"
    v-on="$listeners"
    :editable="toEditable"
    @change="$emit('toChanged', $event)"
    )
</template>

<script>
import UserUniversalTile from '@/components/UserUniversalTile.vue';

export default {
  name: 'UserAssigningTile',
  components: { UserUniversalTile },
  props: {
    from: Object,
    to: Object,
    fromEditable: Boolean,
    toEditable: Boolean,
  },
};
</script>

<style scoped lang="scss">
  .user-assigning {
    display: flex;
    align-items: center;

    &__arrow {
      display: flex;
      align-items: center;
      margin: 0 20px;

      &:before {
        content: '';
        display: block;
        width: 54px;
        height: 2px;
        background: #D1D9F0;
      }

      &:after {
        content: '';
        display: block;
        border: 4px solid transparent;
        border-left-color: #D1D9F0;
      }
    }

    @media (max-width: 576px) {
      display: grid;
      grid-template-columns: max-content min-content;
      row-gap: 10px;

      &__arrow {
        &:before {
          width: 20px;
        }
      }
    }
  }
</style>
